import { ConnectionStatusToName } from '@/src/modules/connections/components/MirrorRegistryStatusBadge/constants';
import { MirrorRegistryStatusBadge } from '@/src/modules/connections/components/MirrorRegistryStatusBadge/MirrorRegistryStatusBadge';
import type React from 'react';
import { MirrorRegistryStatusIcon } from './MirrorRegistryStatusIcon';
import type { ApiMirrorRegistryStatus } from '@fabric-app/types/connections';
import { isTruthy } from '@fabric-app/utils/guards';
import Tooltip from '@fabric-app/ui/components/Tooltip';
import { getTransformedMirrorRegistryMessage } from '../../constants';

export const MirrorRegistryStatusIndicator: React.FC<{
  variant: 'badge' | 'icon';
  status: ApiMirrorRegistryStatus;
  /**
   * messages from mirrorRegistry.message are mapped to a more user-friendly message
   */
  tooltipMessage?: string | null;
  className?: string;
  style?: React.CSSProperties;
}> = ({ variant, status, tooltipMessage: tooltipMessageProp, className, style }) => {
  const Component = variant === 'badge' ? MirrorRegistryStatusBadge : MirrorRegistryStatusIcon;

  const tooltipMessage = getTransformedMirrorRegistryMessage(tooltipMessageProp);

  /**
   * if it's a icon, we want to show the tooltip with at least the base status
   */
  const mergedTooltipMessage = (
    variant === 'icon' ? [ConnectionStatusToName[status], tooltipMessage] : [tooltipMessage]
  )
    .filter(isTruthy)
    .join(' – ');

  if (mergedTooltipMessage) {
    return (
      <Tooltip label={mergedTooltipMessage} placement="top" delay={0}>
        <Component style={style} status={status} className={className} />
      </Tooltip>
    );
  }

  return <Component style={style} status={status} className={className} />;
};
